<template>
	<article class="event">
		<p class="event__noti">기존 (구)이벤트 페이지는 검색만 가능합니다.</p>
		<form @submit.prevent="search()">
			<managing-section :column-count="2">
				<ManagingBox title="이벤트명">
					<input
						type="text"
						placeholder="이벤트명을 입력하세요"
						v-model="boardTitle"
					/>
				</ManagingBox>
				<ManagingBox title="기간">
					<DateRange v-model="range" type="date" />
				</ManagingBox>
				<ManagingBox title="클라이언트">
					<SearchBrand ref="searchBrand" @change="setBrand($event)" />
				</ManagingBox>
				<ManagingBox title="구분">
					<RadioList :radioList="typeList" v-model="type" />
				</ManagingBox>
			</managing-section>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue">검색하기</button>
				<button type="button" class="btn-main" @click="searchReset">
					검색조건 초기화
				</button>
			</div>
		</form>
		<ManagingSection :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					<span>등록 : {{ total }}건</span>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>번호</th>
						<th>등록일</th>
						<th>구분</th>
						<th>이벤트명</th>
						<th>클라이언트</th>
						<th>시작일</th>
						<th>종료일</th>
						<th>조회</th>
						<th>이벤트 제품</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="list in list" :key="list.idAdminBoard">
						<td>{{ list.idAdminBoard }}</td>
						<td>{{ list.createdAt }}</td>
						<td>{{ list.isEvaluated ? '평가단' : '일반' }}</td>
						<td>{{ list.boardTitle }}</td>
						<td>{{ list.brand.brandTitle }}</td>
						<td>{{ list.startedAt }}</td>
						<td>{{ list.endedAt }}</td>
						<td>{{ list.hitsCount }}</td>
						<td>
							<button
								class="btn blue"
								:disabled="!list.productList"
								@click="viewProductList(list.productList)"
							>
								제품보기
							</button>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:total-item="total"
				:limit="limit"
				:offset="offset"
				@to="paging($event.offset)"
			/>
		</ManagingSection>
	</article>
</template>
<script>
	import DateRange from '../../components/DateRange.vue';
	import ManagingBox from '../../components/layout/ManagingBox.vue';
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	import PaginationBox from '../../components/PaginationBox.vue';
	import RadioList from '../../components/RadioList.vue';
	import SearchBrand from '../../components/SearchBrand.vue';
	import { formattedDate } from '../../util';
	export default {
		components: {
			ManagingBox,
			ManagingSection,
			RadioList,
			DateRange,
			SearchBrand,
			PaginationBox,
		},
		data() {
			return {
				type: 'all',
				typeList: [
					{ id: 'all', value: '전체' },
					{ id: 'general', value: '일반' },
					{ id: 'evaluation', value: '평가단' },
				],
				range: {
					from: '',
					to: '',
				},
				offset: 0,
				limit: 10,
				list: [],
				total: 0,
				boardTitle: '',
				idBrand: '',
				brandTitle: '',
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			search() {
				this.offset = 0;
				this.getList();
			},
			setBrand(event) {
				this.idBrand = event.idBrand;
				this.brandTitle = event.brandTitle;
			},
			searchReset() {
				this.boardTitle = '';
				this.range = {
					from: '',
					to: '',
				};
				this.idBrand = '';
				this.$refs.searchBrand.init();
				this.type = 'all';
			},
			async getList() {
				try {
					const params = {
						isEvaluated:
							this.type === 'all'
								? ''
								: this.type === 'general'
									? false
									: true,
						boardTitle: this.boardTitle,
						minDate: this.range.from,
						maxDate: this.range.to,
						idBrand: this.idBrand,
						limit: this.limit,
						offset: this.offset,
					};

					const { data } = await this.$axiosAdmin2.get(
						`/api/old/event`,
						{ params }
					);

					this.list = data.data.map(item => {
						return {
							...item,
							createdAt: formattedDate(item.createDate),
							startedAt: formattedDate(item.startDate),
							endedAt: formattedDate(item.endDate),
						};
					});
					this.total = data.contentTotal;
				} catch (error) {
					console.error(error);
					alert(
						'리스트를 불러오는것을 실패했습니다. 지속적인 발생시 개발팀에 문의해주세요.'
					);
				}
			},
			paging(offset = 0) {
				this.offset = offset;
				this.getList();
			},
			viewProductList(productList) {
				this.$store.commit('modal/toggleModal', {
					id: 'EventProductList',
					params: productList,
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.event {
		&__noti {
			font-size: 16px;
			margin-top: 20px;
			color: red;
		}
	}
</style>
